// extracted by mini-css-extract-plugin
module.exports = {"Layout":"layout_Layout__2A_Ds","Header":"layout_Header__3QZq6"};